import { Component, Input, TemplateRef, input } from '@angular/core';
import { PDSButtonType } from '../../directives/button/button.directive';

@Component({
  selector: 'pds-module-header',
  templateUrl: './module-header.component.html',
  styleUrls: ['./module-header.component.scss'],
  standalone: false,
})
export class ModuleHeaderComponent {
  @Input()
  ctaTemplate: TemplateRef<unknown> | null = null;

  @Input()
  title!: string;

  @Input()
  ctaPath: string | undefined;

  @Input()
  ctaLabel: string | undefined;

  @Input()
  ctaOnClick: (() => void) | undefined;

  @Input()
  ctabuttonType: PDSButtonType | undefined;

  @Input()
  modifier: 'primary' | 'outlined' | undefined;

  height = input<string>('');
}
